<h2 class="mb-10">Confirmação</h2>
<p class="mb-5">{{mensagem}}</p>
<div class="button-container">
    <button type="button" class="btn btn-light" (click)="onNoClick()">Não</button>
    <button type="button" class="btn btn-primary" *ngIf="!isInscrito" (click)="onYesClick()">Sim</button>
    <button type="button" class="btn btn-primary" *ngIf="isInscrito && data.vaga.pcd" (click)="onYesClickPcd()">Sim</button>
</div>
